import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum CrmOfferStatusId {
  NEW = 'new',
  SENT = 'sent',
  SIGNED = 'signed',
}

export class CrmOfferStatus extends Codebook<CrmOfferStatusId> {
  static readonly NEW = new CrmOfferStatus(CrmOfferStatusId.NEW, () => $t('New'), Color.INFO)
  static readonly SENT = new CrmOfferStatus(CrmOfferStatusId.SENT, () => $t('Sent'), Color.WARNING)
  static readonly SIGNED = new CrmOfferStatus(
    CrmOfferStatusId.SIGNED,
    () => $t('Signed'),
    Color.POSITIVE,
  )

  private constructor(
    id: CrmOfferStatusId,
    public readonly name: () => string,
    public readonly color: Color.INFO | Color.WARNING | Color.POSITIVE,
  ) {
    super(id)
  }
}
